// extracted by mini-css-extract-plugin
export default {"container":"StatusDisplay_container__Kdw-+","pending":"StatusDisplay_pending__f5Qva","accepted":"StatusDisplay_accepted__PSWr8","rejected":"StatusDisplay_rejected__V6SnG"};